module.exports = __webpack_public_path__ + "img/step2-02.34d562db.png";